import React from 'react';

export function CreditPackCard({ pack, onSelect, disabled }) {
  const priceUsd = parseFloat(pack?.priceUsd || 0);
  const credits = parseInt(pack?.credits || 0, 10);

  const handleClick = (e) => {
    e.stopPropagation();
    if (disabled || !onSelect) return;
    onSelect(pack);
  };

  return (
    <div
      className="credit-pack-card"
      style={{
        width: '260px',
        flexShrink: 0,
        height: '100%',
        minHeight: '280px',
        boxSizing: 'border-box',
        background: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        padding: '20px',
        cursor: disabled ? 'default' : 'pointer',
        transition: 'all 0.3s ease',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
      }}
      onClick={handleClick}
      onMouseEnter={(e) => {
        if (disabled) return;
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)';
        e.currentTarget.style.transform = 'translateY(-3px)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 139, 69, 0.25)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      {pack?.badge && (
        <div
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            padding: '3px 8px',
            background: 'rgba(0, 139, 69, 0.35)',
            border: '1px solid rgba(0, 139, 69, 0.6)',
            borderRadius: '999px',
            fontSize: '11px',
            color: '#9ee7c0',
            fontWeight: 500,
          }}
        >
          {pack.badge}
        </div>
      )}

      <div
        style={{
          flexShrink: 0,
          paddingRight: pack?.badge ? '76px' : 0,
        }}
      >
        <h3 style={{ margin: 0, fontSize: '20px', color: '#fff', fontWeight: 600 }}>
          {pack?.displayName || pack?.name}
        </h3>
        {pack?.description && (
          <p style={{ margin: '6px 0 0 0', fontSize: '13px', color: '#aaa', lineHeight: 1.4 }}>
            {pack.description}
          </p>
        )}
      </div>

      <div
        style={{
          marginTop: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          flexShrink: 0,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
          <span style={{ fontSize: '30px', fontWeight: 700, color: '#fff', lineHeight: 1 }}>
            ${priceUsd.toFixed(2)}
          </span>
          <span style={{ fontSize: '13px', color: '#999' }}>one-time</span>
        </div>

        <div
          style={{
            padding: '10px 12px',
            background: 'rgba(0, 139, 69, 0.12)',
            border: '1px solid rgba(0, 139, 69, 0.25)',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'baseline',
            gap: '8px',
          }}
        >
          <div style={{ fontSize: '20px', fontWeight: 700, color: '#9ee7c0', lineHeight: 1 }}>
            {credits.toLocaleString()}
          </div>
          <div style={{ fontSize: '12px', color: '#aaa' }}>credits</div>
        </div>

        <button
          onClick={handleClick}
          disabled={disabled}
          style={{
            width: '100%',
            padding: '10px 16px',
            background: disabled ? 'rgba(100, 100, 100, 0.3)' : 'rgba(0, 139, 69, 0.6)',
            border: `1px solid ${disabled ? 'rgba(100, 100, 100, 0.5)' : 'rgba(0, 139, 69, 0.9)'}`,
            borderRadius: '8px',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 600,
            cursor: disabled ? 'default' : 'pointer',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            if (!disabled) e.currentTarget.style.background = 'rgba(0, 139, 69, 0.8)';
          }}
          onMouseLeave={(e) => {
            if (!disabled) e.currentTarget.style.background = 'rgba(0, 139, 69, 0.6)';
          }}
        >
          {disabled ? 'Starting...' : 'Buy Credits'}
        </button>
      </div>
    </div>
  );
}
